export default {
  SET_IS_SHOWN: (state, value) => { state.isShown = value; },
  SET_EDIT_ID: (state, id) => { state.editId = id; },
  SET_MENU_LIST: (state, pages) => { state.menuList = pages; },

  SET_IS_PAGE_EDITABLE(state, page) {
    state.isMenuEditable = page || {};
  },

  UPDATE_IS_MENU_FIELD(state, {
    key, value,
  }) {
    if (!state.isMenuEditable) state.isMenuEditable = {};
    state.isMenuEditable[key] = value;
  },

  UPDATE_TRANSLATION(state, {
    locale, field, value,
  }) {
    if (!state.isMenuEditable.translations) state.isMenuEditable.translations = {};
    if (!state.isMenuEditable.translations[locale]) state.isMenuEditable.translations[locale] = {};
    state.isMenuEditable.translations[locale][field] = value;
  },

  RESET_EDITOR_STATE(state) {
    state.editId = null;
    state.isMenuEditable = {};
    state.menuList = [];
  },
  SET_PARENT_SIDEBAR_ITEMS(state) {
    state.parentSidebarItems = state.menuList.filter((item) => item.url.indexOf('-group') !== -1);
  },
};
